export default __webpack_public_path__ + "static/media/Sume_JachenSchleich.512712da.png";